/**
 * AR Ageing — Customer ageing analysis.
 * Thin wrapper: locks party type to Customer.
 */
import { AgeingPage } from '@/pages/fin/AgeingPage';

export const ArAgeingPage = () => (
  <AgeingPage defaultPartyType="Customer" lockPartyType />
);
